import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="w-full bg-[#1a0000] py-16 px-4" data-id="element-388">
      <div className="max-w-3xl mx-auto text-center" data-id="element-389">
        <h2 className="text-2xl sm:text-3xl font-black text-white mb-8" data-id="element-390">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className="mb-6" data-id="element-391">
          <CountdownTimer size="lg" blinking={true} data-id="element-392" />
        </div>

        <p className="text-white text-lg font-bold mb-10" data-id="element-393">
          Después sube{' '}
          <span className="text-[#FF0000] font-black" data-id="element-394">$8.000 ARS</span> y no
          vuelve a bajar.
        </p>

        {/* Progress bar */}
        <div className="mb-10" data-id="element-395">
          <div className="flex items-center justify-between mb-2" data-id="element-396">
            <span className="text-[#FF0000] font-bold text-sm" data-id="element-397">
              🔴 Cupos al precio de lanzamiento
            </span>
            <span className="text-white text-sm font-bold" data-id="element-398">Quedan pocos</span>
          </div>
          <div className="w-full bg-gray-800 rounded-full h-4 overflow-hidden" data-id="element-399">
            <div className="h-full rounded-full bg-gradient-to-r from-[#FF0000] to-[#FF6600]" style={{
            width: '68%'
          }} data-id="element-400" />
          </div>
          <p className="text-gray-400 text-xs mt-2 text-right" data-id="element-401">
            68% de los cupos tomados
          </p>
        </div>
      </div>
    </section>;
}